module.exports = __webpack_public_path__ + "81a13f5268b97a5a94e0e46abaae928b.jpg";